import { Injectable, inject } from '@angular/core';
import { SseLiveConnectionService } from '@tuain/ng-forms';
import { EventManagerService } from './event-manager.service';
import { defaultConfig } from 'src/app/app.config';

const { sessionEstablished, sessionEnded } = defaultConfig.appEvents;

/**
 * Wiring del ciclo de vida del canal en vivo para esta app.
 *
 * El transporte (SSE), la allow-list de eventos, el manejo de `sessionReplaced`
 * y la reconexión viven en `SseLiveConnectionService` (@tuain/ng-forms),
 * configurado por la app vía `SSE_LIVE_CONNECTION_CONFIG`
 * (ver `provideSseLiveConnection()` en main.ts).
 *
 * Este servicio solo decide CUÁNDO abrir/cerrar el stream según los eventos de
 * sesión, preservando el punto de instanciación previo (app-base-form lo
 * resuelve por `injector.get`, lo que dispara las suscripciones).
 */
@Injectable({ providedIn: 'root' })
export class LiveConnectionService {
  private _sse = inject(SseLiveConnectionService);
  private _eventManager = inject(EventManagerService);

  constructor() {
    this._eventManager.subscribe(sessionEstablished.name, data => {
      if (data && defaultConfig?.liveConnection) {
        this._sse.open(data?.sessionData);
      }
    });
    this._eventManager.subscribe(sessionEnded.name, () => this._sse.close());
  }
}
